import { SiteHeader, SiteFooter } from "@/components/demo/DemoShell";
import { Star } from "lucide-react";

const MAIN_IMG =
  "https://images.pexels.com/photos/8004070/pexels-photo-8004070.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=900";

const RELATED = [
  {
    img: "https://images.pexels.com/photos/13068366/pexels-photo-13068366.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=600&w=600",
    title: "Sample Product A",
    price: "$24",
  },
  {
    img: "https://images.unsplash.com/photo-1660405096711-ad0ea51c2333?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwzfHxtaW5pbWFsJTIwYWJzdHJhY3R8ZW58MHx8fHdoaXRlfDE3ODc2MTU2MDV8MA&ixlib=rb-4.1.0&q=85&w=600",
    title: "Sample Product B",
    price: "$32",
  },
  {
    img: "https://images.unsplash.com/photo-1660400890783-68e302571c5e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHxtaW5pbWFsJTIwYWJzdHJhY3R8ZW58MHx8fHdoaXRlfDE3ODc2MTU2MDV8MA&ixlib=rb-4.1.0&q=85&w=600",
    title: "Sample Product C",
    price: "$19",
  },
  {
    img: "https://images.unsplash.com/photo-1542903107-db6be5823cba?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHw0fHxtaW5pbWFsJTIwYWJzdHJhY3R8ZW58MHx8fHdoaXRlfDE3ODc2MTU2MDV8MA&ixlib=rb-4.1.0&q=85&w=600",
    title: "Sample Product D",
    price: "$41",
  },
];

export default function DemoProduct() {
  return (
    <div data-testid="demo-product" className="min-h-screen bg-white text-slate-900">
      <SiteHeader />

      {/* Product detail */}
      <section data-testid="product-detail" className="mx-auto max-w-6xl px-5 pt-16 pb-12 sm:px-8 sm:pt-24">
        <div className="grid gap-10 lg:grid-cols-2">
          <div data-testid="product-image-wrap">
            <img
              data-testid="product-image"
              src={MAIN_IMG}
              alt="Sample product"
              className="aspect-square w-full rounded-2xl object-cover ring-1 ring-slate-200"
            />
          </div>

          <div data-testid="product-info" className="flex flex-col justify-center">
            <span className="text-xs font-semibold uppercase tracking-widest text-indigo-600">
              Sample Category
            </span>
            <h1 data-testid="product-title" className="mt-3 text-3xl font-bold tracking-tight sm:text-4xl">
              Sample Product
            </h1>
            <div data-testid="product-rating" className="mt-3 flex items-center gap-2 text-sm text-slate-500">
              <span className="flex">
                {Array.from({ length: 5 }).map((_, i) => (
                  <Star key={i} className={`h-4 w-4 ${i < 4 ? "fill-amber-400 text-amber-400" : "text-slate-300"}`} />
                ))}
              </span>
              <span>4.0 · 128 reviews</span>
            </div>
            <p data-testid="product-description" className="mt-5 text-[15px] leading-relaxed text-slate-600">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas
              faucibus mollis interdum. Cras justo odio, dapibus ac facilisis in,
              egestas eget quam. Donec id elit non mi porta gravida at eget metus.
            </p>
            <div className="mt-6 flex items-baseline gap-3">
              <span data-testid="product-price" className="text-3xl font-bold text-slate-900">$29</span>
              <span className="text-lg text-slate-400 line-through">$39</span>
            </div>
            <button
              data-testid="product-buy-button"
              className="mt-7 w-full rounded-lg bg-indigo-600 py-3.5 text-sm font-semibold text-white transition-colors hover:bg-indigo-700 sm:w-auto sm:px-10"
            >
              Add to cart
            </button>
            <p className="mt-4 text-xs text-slate-400">Free sample shipping · 30-day returns</p>
          </div>
        </div>
      </section>

      {/* Related grid */}
      <section data-testid="product-related" className="mx-auto max-w-6xl px-5 py-8 sm:px-8">
        <h2 className="text-xl font-semibold tracking-tight">You may also like</h2>
        <div className="mt-6 grid grid-cols-2 gap-5 lg:grid-cols-4">
          {RELATED.map((p, i) => (
            <div key={p.title} data-testid={`related-card-${i + 1}`} className="group">
              <div className="overflow-hidden rounded-xl ring-1 ring-slate-200">
                <img
                  src={p.img}
                  alt={p.title}
                  className="aspect-square w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <h3 className="mt-3 text-sm font-medium text-slate-900">{p.title}</h3>
              <p className="text-sm text-slate-500">{p.price}</p>
            </div>
          ))}
        </div>
      </section>

      <SiteFooter />
    </div>
  );
}
